export const muiTypography = {
  fontFamily: 'Museo Sans',
  fontWeightLight: 300,
  fontWeightRegular: 500,
  fontWeightMedium: 700,
  fontWeightBold: 900,
  typography: {
    fontFamily: 'Museo Sans, sans-serif',
    fontWeight: 'inherit',
    hero1: {
      fontWeight: 700,
      fontSize: '40px',
      lineHeight: '52px',
      letterSpacing: '0.005em'
    },
    h1: {
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '28px',
      letterSpacing: '-0.015em'
    },
    h2: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '28px',
      letterSpacing: '-0.005em'
    },
    h3: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '28px'
    },
    h4: {
      fontWeight: 500,
      fontSize: '34px',
      lineHeight: '40px',
      letterSpacing: '0.0025em'
    },
    h5: {
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '28px',
      letterSpacing: '0em'
    },
    h6: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.0015em'
    },
    subtitle1: {
      fontWeight: 300,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.0015em'
    },
    subtitle2: {
      fontWeight: 300,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.001em'
    },
    body1: {
      fontWeight: 300,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.005em'
    },
    body2: {
      fontFamily: 'Museo Sans',
      fontWeight: 300,
      fontSize: '13px',
      lineHeight: '20px',
      letterSpacing: '0.0025em'
    },
    button: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.0125em',
      textTransform: 'none'
    },
    caption: {
      fontFamily: 'Museo Sans',
      fontWeight: 300,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.004em'
    },
    overline: {
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: '28px',
      letterSpacing: '0.015em',
      textTransform: 'uppercase'
    }
  }
};
